import { render, staticRenderFns } from "./PageStaffListTable.vue?vue&type=template&id=8f89724e"
import script from "./PageStaffListTable.vue?vue&type=script&lang=js"
export * from "./PageStaffListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports